import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Box, Typography, Button, CircularProgress } from "@material-ui/core";
import OpenInNewRoundedIcon from "@material-ui/icons/OpenInNewRounded";
import FolderOpenRoundedIcon from "@material-ui/icons/FolderOpenRounded";
import {
  getFreshReportUrlRequest,
  getChatbotReportUrlRequest,
} from "../../../PatientApiActions";

// Fetches the latest report for a patient and embeds its PDF via a freshly-signed
// link (re-signed on demand, as the stored pdf_url expires). Source is a Strapi
// `collection` or a `chatbotType`; no report shows an empty state.
const PdfReportViewer = ({ phone, collection, chatbotType }) => {
  const dispatch = useDispatch();
  const [status, setStatus] = useState("loading"); // loading | ready | empty | error
  const [pdfUrl, setPdfUrl] = useState(null);

  useEffect(() => {
    if (!phone) {
      setStatus("empty");
      return undefined;
    }

    let active = true;
    setStatus("loading");
    const request = chatbotType
      ? getChatbotReportUrlRequest(phone, chatbotType)
      : getFreshReportUrlRequest(collection, phone);
    dispatch(request)
      .then((res) => {
        if (!active) return;
        if (res && res.url) {
          setPdfUrl(res.url);
          setStatus("ready");
        } else {
          setStatus("empty");
        }
      })
      .catch(() => {
        if (active) setStatus("error");
      });

    return () => {
      active = false;
    };
  }, [dispatch, collection, phone, chatbotType]);

  if (status === "loading") {
    return (
      <Box display="flex" justifyContent="center" my={4}>
        <CircularProgress />
      </Box>
    );
  }

  if (status === "ready" && pdfUrl) {
    return (
      <Box>
        <Box display="flex" justifyContent="flex-end" mb={1}>
          <Button
            size="small"
            variant="outlined"
            startIcon={<OpenInNewRoundedIcon />}
            onClick={() => window.open(pdfUrl, "_blank", "noopener")}
          >
            Open in new tab
          </Button>
        </Box>
        <iframe
          title="report-pdf"
          src={pdfUrl}
          style={{ width: "100%", height: "70vh", border: "none" }}
        />
      </Box>
    );
  }

  return (
    <Box textAlign="center" py={5}>
      <FolderOpenRoundedIcon style={{ fontSize: 48, color: "#bdbdbd" }} />
      <Typography style={{ marginTop: 8, fontWeight: 600 }}>
        {status === "error" ? "Couldn't load report" : "No report available"}
      </Typography>
      <Typography variant="body2" color="textSecondary" style={{ marginTop: 4 }}>
        {status === "error"
          ? "There was a problem fetching this report. Please try again."
          : "No PDF report has been published for this patient yet."}
      </Typography>
    </Box>
  );
};

export default PdfReportViewer;
